import { AddressDetails, CustomerAddress } from '@framework/types';

export function formatAddress(address: AddressDetails) {
  return `${address.street_address}, ${address.zip} ${address.city}`;
}

export function formatCustomerAddress(address: CustomerAddress) {
  return `${address.street_address}, ${address.zip} ${address.city}`;
}
